import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import OffersCarousel from "src/components/OffersCarousel";
import AnalyticsService from "src/services/AnalyticsService";
import { isPpcPage } from "src/services/NoIndexService";
import styles from "./styles.scss";

const OfferCarouselModal = () => {
  const router = useRouter();
  const [show, setShow] = useState(false);

  // Brian's request
  useEffect(() => {
    if (isPpcPage(router?.asPath)) {
      setTimeout(() => {
        setShow(true);
      }, 5000);
    }
  }, []);

  const close = () => {
    AnalyticsService.track("Close Sportsbook Offers Modal", {});
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div className="offer-carousel-modal">
      <OffersCarousel />
      <div className="close-btn" onClick={close}>
        <Icon path={mdiClose} size="22px" color="#fff" />
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default OfferCarouselModal;
